// import React from 'react'

// const HomeContact = () => {
//     return (
//         <div className='bgevent' >
//             <main className='row pt-5  pe-0 container-fluid ' >
//                 <section className='col-lg-4 flex ' >
//                     <img src={require('../../Assest/cards/building.avif')} className='mt-auto ' alt="Building" />
//                 </section>
//                 <section className='col-lg-8 px-5   ' >
//                     <div className='rounded shadow bg-slate-50 mb-5 bg-opacity-50 p-4 border-2 w-full min-h-[10vh] backdrop-blur-sm ' >
//                         <h4 className='text-center txtgrd text-3xl fw-semibold ' >Get in Touch </h4>
//                         <article className='flex gap-3 ' >
//                             <div className='w-5/6 ' >
//                                 <p className='fw-semibold ' >Full Name</p>
//                                 <input type="text" placeholder='Full name'
//                                     className=' w-full rounded outline-none border-2 border-slate-300 block border-opacity-70 p-2 ' />
//                             </div>
//                             <div className='w-5/6 ' >
//                                 <p className='fw-semibold ' >Email</p>
//                                 <input type="text" placeholder='Full name'
//                                     className=' w-full rounded outline-none border-2 border-slate-300 block border-opacity-70 p-2 ' />
//                             </div>
//                         </article>
//                         <div className=' my-3' >
//                             <p className='fw-semibold ' >Subject</p>
//                             <input type="text" placeholder='Full name'
//                                 className=' w-full rounded outline-none border-2 border-slate-300 block border-opacity-70 p-2 ' />
//                         </div>
//                         <div className='' >
//                             <p className='fw-semibold ' >How can we help you?</p>
//                             <textarea rows={5} type="text" placeholder='Describe your problem in at least 250 characters'
//                                 className=' w-full rounded outline-none border-2 border-slate-300 block border-opacity-70 p-2 ' />
//                         </div>
//                         <button className='p-2 px-3 mx-auto rounded flex mt-3 text-sm bg-blue-500 text-white ' >
//                             Send Message
//                         </button>
//                     </div>

//                 </section>

//             </main>

//         </div>
//     )
// }

// export default HomeContact



import React from 'react';
import { motion } from 'framer-motion';
import { Send, Mail, Phone } from 'lucide-react';

const HomeContact = () => {
    return (
        <section className="bg-white py-10 relative overflow-hidden">
            {/* Subtle light background */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-slate-50/50 blur-[120px] rounded-full -z-0" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-5xl mx-auto">
                    <div className="flex flex-col lg:flex-row gap-20">
                        
                        {/* LEFT: MINIMAL TEXT */}
                        <div className="lg:w-1/3 space-y-8">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                            >
                                <p className="text-blue-600 font-bold tracking-[0.3em] text-[10px] uppercase mb-4">Contact</p>
                                <h2 className="text-3xl md:text-5xl font-bold text-slate-900 syne leading-tight mb-6">
                                    Let's talk <br /> <span className="text-blue-600">business.</span>
                                </h2>
                                <p className="text-slate-500 text-sm md:text-lg leading-relaxed">
                                    Ready to optimize your workforce? Send us a message and we'll reach out shortly.
                                </p>
                            </motion.div>

                            <div className="space-y-4 pt-4">
                                <div className="flex items-center gap-3 text-slate-600 group cursor-pointer">
                                    <Mail size={18} className="text-blue-500 group-hover:scale-110 transition-transform" />
                                    <span className="text-sm font-medium">hello@meridahr.com</span>
                                </div>
                                <div className="flex items-center gap-3 text-slate-600 group cursor-pointer">
                                    <Phone size={18} className="text-blue-500 group-hover:scale-110 transition-transform" />
                                    <span className="text-sm font-medium">+91 98765 43210</span>
                                </div>
                            </div>

                            <img 
                                src={require('../../Assest/cards/building.avif')} 
                                className="w-40 opacity-10 grayscale mt-12" 
                                alt="Building" 
                            />
                        </div>

                        <motion.div 
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            className="lg:w-2/3 bg-white border border-slate-100 p-8 md:p-12 rounded-[2rem] shadow-xl shadow-slate-200/50"
                        >
                            <form className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-10">
                                {/* Name Input */}
                                <div className="relative group">
                                    <input 
                                        type="text" 
                                        className="w-full bg-transparent border-b border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                        placeholder=" "
                                    />
                                    <label className="absolute left-0 top-3 text-slate-800 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                        Full Name
                                    </label>
                                </div>

                                {/* Email Input */}
                                <div className="relative group">
                                    <input 
                                        type="email" 
                                        className="w-full bg-transparent border-b border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                        placeholder=" "
                                    />
                                    <label className="absolute left-0 top-3 text-slate-800 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                        Email Address
                                    </label>
                                </div>

                                {/* Subject Input */}
                                <div className="relative group md:col-span-2">
                                    <input 
                                        type="text" 
                                        className="w-full bg-transparent border-b border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                        placeholder=" "
                                    />
                                    <label className="absolute left-0 top-3 text-slate-800 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                        Subject
                                    </label>
                                </div>

                                {/* Message Input */}
                                <div className="relative group md:col-span-2">
                                    <textarea 
                                        rows={3}
                                        className="w-full bg-transparent border-b border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800 resize-none"
                                        placeholder=" "
                                    />
                                    <label className="absolute left-0 top-3 text-slate-800 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                        How can we help?
                                    </label>
                                </div>

                                {/* Submit Button */}
                                <div className="md:col-span-2 flex justify-end">
                                    <motion.button 
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                        className="bg-blue-600 text-white px-5 py-3 rounded-full font-bold flex items-center gap-3 shadow-lg shadow-blue-600/20 hover:bg-blue-700 transition-all"
                                    >
                                        Send Message
                                        <Send size={16} />
                                    </motion.button>
                                </div>
                            </form>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeContact;